import { ContentItem } from 'kentico-cloud-delivery';
import get from 'lodash/get';

export default class ForInvestorsNews extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`
    });
  }

  get img() {
    return get(this, '_obraz.value[0]', '');
  }

  get title() {
    return get(this, '_tytul.value', '');
  }

  get date() {
    return get(this, '_data.value', '');
  }

  get href() {
    return get(this, '_link.value', '');
  }
}



// WEBPACK FOOTER //
// ./src/models/ForInvestorsNews.model.js